import EventEmitter from 'events';

class Value {
  constructor(center, config, id) {
    this.type = 'VALUE';
    this.center = center;
    this.config = config || {};
    this.name = this.config.name;
    this.initialData = this.config.initialData;
    this.exports = this.config.exports;
    this.variables = null;
    this.emitter = new EventEmitter();
    this.id = id;
  }

  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getConfig(key) {
    return key ? this.config[key] : this.config;
  }

  execute() {
    // 描述自身是否变化过
    let changed;
    if (!this.valueSet && (!('usedTokens' in this) || Object.keys(this.usedTokens).length)) {
      // 自身值受其他值控制
      const usedTokens = {};
      const rendered = this.center.parseRecursion(this.initialData, false, {}, usedTokens);
      changed = this.hash !== JSON.stringify(rendered);
      this.data = rendered;
      this.usedTokens = usedTokens;
      this.makeVariables();
    } else if (this.valueSet && !this.synced) {
      // setValue已经执行过，不过还没有execute
      changed = true;
      this.makeVariables();
      this.synced = true;
    }

    return Promise.resolve({ value: this.getVariables(), changed });
  }

  setValue(value) {
    this.valueSet = true;
    if (this.hash !== JSON.stringify(value)) {
      this.data = value;
      this.synced = false;
    }
  }

  makeVariables() {
    // simple hash
    this.hash = JSON.stringify(this.data);
    if (!this.exports || !Array.isArray(this.exports) || this.exports.length < 1) {
      this.variables = this.data;
      return;
    }
    this.variables = {};
    if (!this.data) return;

    this.exports.forEach((item) => {
      if (this.data[item.field] != null) {
        this.variables[item.name] = this.data[item.field];
      } else {
        this.variables[item.name] = item.defaultValue || '';
      }
    });
  }

  getVariables() {
    return this.variables;
  }

  onChange(func) {
    this.emitter.on('change', func);
    return () => {
      this.emitter.removeListener('change', func);
    };
  }
}

export default Value;
